export class Country {
	public constructor(public readonly id: string, public readonly isoCode: string, public readonly name: string) {}
}
